var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83874 26.5167C8.25295 25.9309 8.25295 24.9812 8.83874 24.3954L24.3951 8.83905C24.9809 8.25326 25.9306 8.25326 26.5164 8.83905V8.83905C27.1022 9.42483 27.1022 10.3746 26.5164 10.9604L10.9601 26.5167C10.3743 27.1025 9.42452 27.1025 8.83874 26.5167V26.5167Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83875 8.83898C9.42454 8.25319 10.3743 8.25319 10.9601 8.83898L26.5164 24.3953C27.1022 24.9811 27.1022 25.9309 26.5164 26.5166V26.5166C25.9306 27.1024 24.9809 27.1024 24.3951 26.5166L8.83875 10.9603C8.25297 10.3745 8.25297 9.42477 8.83875 8.83898V8.83898Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4f823f835b9e87ef96d4c8aaf14a3f84.svg";
export { ForwardRef as ReactComponent };